import { ApiClient } from "@/api-client/src/core/api-client";
import {
  HomeBanner,
  HomeBannersResponse,
  HomePromotionalBannersResponse,
  HomeSliderResponse,
} from "@/packages/types/banner";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchAllHomeBanners = async (): Promise<HomeBannersResponse> => {
  const response = await webService.get<HomeBannersResponse>(`/banners`);

  console.log("fetchAllHomeBanners response:", response); // Log the response for debugging
  return response;
};

export const fetchAllHomeSliders = async (): Promise<HomeSliderResponse> => {
  const response = await webService.get<HomeSliderResponse>(`/sliders`);
  return response;
};
export const fetchAllPromotionalBanners = async (): Promise<HomeBanner[]> => {
  const response = await webService.get<HomePromotionalBannersResponse>(
    `/promo-cards`
  );
  return response.data;
};
export const fetchAllAdditionalBanners = async (): Promise<HomeBanner[]> => {
  const response = await webService.get<HomePromotionalBannersResponse>(
    `/additional-sliders`
  );
  return response.data;
};
